import { render, staticRenderFns } from "./gc-hot-key.vue?vue&type=template&id=6ee6d624&"
import script from "./gc-hot-key.vue?vue&type=script&lang=js&"
export * from "./gc-hot-key.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports